/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_BrowserInputs */

const en_method_browser = /** @type {(inputs: Method_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`browser`)
};

const he_method_browser = /** @type {(inputs: Method_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`דפדפן`)
};

/**
* | output |
* | --- |
* | "browser" |
*
* @param {Method_BrowserInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const method_browser = /** @type {((inputs?: Method_BrowserInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_BrowserInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_method_browser(inputs)
	return he_method_browser(inputs)
});